// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220937/js/" + chunkId + "." + {"44":"57240ffc","225":"94a6fca3","481":"e771b8ea","486":"66209b5d","770":"1b5c42d0"}[chunkId] + ".0.2753588088853559.chunk.js";
};